<template>
  <button type="submit" class="btn btn-primary">{{ name }}<slot/></button>
</template>
<script setup>
import {defineProps} from 'vue'
defineProps({
  name: String,
})
</script>
